const SENSITIVE_PAYMENT_PREFIX = "/pay";

export function isSensitivePaymentPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return (
    pathname === SENSITIVE_PAYMENT_PREFIX || pathname.startsWith(`${SENSITIVE_PAYMENT_PREFIX}/`)
  );
}

export function isSensitiveBrowserPath(pathname: string | null | undefined): boolean {
  return (
    isSensitivePaymentPath(pathname) ||
    pathname === "/admin" ||
    Boolean(pathname?.startsWith("/admin/"))
  );
}

export function isBrowserTelemetrySuppressed(): boolean {
  return typeof window !== "undefined" && isSensitiveBrowserPath(window.location.pathname);
}
